module.exports = __webpack_public_path__ + "static/media/laser-light-sheer-desire.5c82c878.md";